import React from 'react'
import {
  GoogleMap,
  withGoogleMap,
  withScriptjs,
  Marker
} from 'react-google-maps'

import { GOOGLE_MAPS_JAVASCRIPT_API } from '../../utils/googleMapsApiKey'

function Mapa({ props }) {
  const item = props.array[0]

  if (!item) return null

  const zoom = props.zoom
  const defaultLatLong = props.defaultLatLong
  const latLong = { lat: item.lat, lng: item.lng }

  return (
    <GoogleMap zoom={zoom || 10} center={latLong}>
      {!defaultLatLong && (
        <Marker
          icon={{
            url: '../../icones/filled-marker-red.svg',
            scaledSize: new window.google.maps.Size(25, 25)
          }}
          position={latLong}
        />
      )}
    </GoogleMap>
  )
}

const WrappedMap = withScriptjs(withGoogleMap(Mapa))

export default function MapaGoogleSemInfo(props) {
  return (
    <div style={{ width: '100%', height: '100%', zoom: '125%' }}>
      <WrappedMap
        props={props}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places,visualization&key=${GOOGLE_MAPS_JAVASCRIPT_API}`}
        loadingElement={<div style={{ height: '100%' }} />}
        containerElement={<div style={{ height: '100%' }} />}
        mapElement={<div style={{ height: '100%' }} />}
      />
    </div>
  )
}
